import { render, staticRenderFns } from "./MNote.vue?vue&type=template&id=67d85424"
import script from "./MNote.vue?vue&type=script&lang=js"
export * from "./MNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports